import { Capacitor } from "@capacitor/core";
import { Device } from "@capacitor/device";

/**
 * Device information.
 */
export interface DeviceInfo {
  platform: "ios" | "android" | "web";
  osVersion: string;
  model?: string;
  manufacturer?: string;
  isVirtual?: boolean;
  webViewVersion?: string;
}

/**
 * Device identifier result.
 */
export interface DeviceId {
  identifier: string;
}

/**
 * Gets the device information.
 * On native platforms, returns detailed device info.
 * On web, returns generic web platform info.
 *
 * @returns Device information
 */
export async function getDeviceInfo(): Promise<DeviceInfo> {
  if (!Capacitor.isNativePlatform()) {
    return {
      platform: "web",
      osVersion: "web-unknown",
    };
  }

  return await Device.getInfo();
}

/**
 * Gets the unique device identifier.
 * On native platforms, returns a unique device ID.
 * On web, returns a persistent identifier stored in localStorage.
 *
 * @returns Device identifier
 */
export async function getDeviceId(): Promise<DeviceId> {
  return await Device.getId();
}
